<template>
  <section v-if="quotationInfo">
    <validation-observer ref="requestSubmit">
      <b-row class="px-2">
        <b-col cols="12" class="pt-1"><h4>Freight Informations</h4></b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            :name="quotationInfo.service_type == 1 ? 'AOL' : 'POL'"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label
                >{{ quotationInfo.service_type == 1 ? "AOL" : "POL"
                }}<font class="red">*</font>
              </label>
              <!-- <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="AOL/POL"
                v-model="quotationInfo.pol_port"
                :options="ports"
              /> -->
              <Select4
                v-model="quotationInfo.pol_port"
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOL/POL"
                :disabled="readonly"
                :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            :name="quotationInfo.service_type == 1 ? 'AOD' : 'POD'"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label
                >{{ quotationInfo.service_type == 1 ? "AOD" : "POD"
                }}<font class="red">*</font></label
              >

              <!-- <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="AOD/POL"
                v-model="quotationInfo.pod_port"
                :options="ports"
              /> -->
              <Select4
                v-model="quotationInfo.pod_port"
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOD/POL"
                :disabled="readonly"
                :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Payment Terms"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Payment Terms</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Payment Terms"
                v-model="quotationInfo.paymentTerms"
                :options="$Options.paymentTerms"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider
            name="Cargo ready"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Cargo ready<font class="red">*</font></label>
              <!-- <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.cargo_ready"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              /> -->
              <date-picker
                ref="datePicker"
                v-model="quotationInfo.cargo_ready"
                type="datetime"
                class="w-full"
                :class="errors.length > 0 ? 'is-invalid' : null"
                value-type="format"
                :disabled="readonly"
                title-format="DD-MM-YYYY"
                time-title-format="DD-MM-YYYY"
                placeholder="Select datetime"
                :show-time-panel="showTimePanel"
                format="DD-MM-YYYY HH:mm"
                @close="handleOpenChange"
              >
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!--  Carrier -->

        <b-col cols="12" lg="6">
          <validation-provider
            name="        Airline
"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Airline</label>

              <Select4
                v-model="quotationInfo.shipping_line"
                :class="[
                  errors.length > 0 ? 'is-invalid' : null,
                  readonly == true ? 'remove' : '',
                ]"
                placeholder="Airline"
                :disabled="readonly"
                :options="{
                  value: 'id',
                  label: 'text',
                  data: shipping_lines,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Shipping Line' },
                  ],
                }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- <b-col cols="12" :lg="isVolume ? '6' : '4'" v-if="!isVolume">
          <b-form-group>
            <label>Volume (Monthly)</label>
            <Select2
              :disabled="readonly"
              placeholder="Volume (Monthly)"
              v-model="quotationInfo.volume"
              :options="$Utils.CONSTANTS.VOLUMES"
            />
          </b-form-group>
        </b-col> -->
        <!-- 
        <b-col cols="12" lg="6">
          <validation-provider
            name="From"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>From<font class="red">*</font></label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                :min="new Date()"
                v-model="quotationInfo.from_date"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="To" #default="{ errors }" rules="required">
            <b-form-group>
              <label>To<font class="red">*</font></label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                :min="
                  quotationInfo.from_date
                    ? new Date(quotationInfo.from_date)
                    : new Date()
                "
                v-model="quotationInfo.to_date"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col> -->
        <b-col cols="6">
          <validation-provider name="ETD" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETD </label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.etd"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="ETA" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETA</label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                v-model="quotationInfo.eta"
                :disabled="readonly"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="pt-1"><h4>Cargo Information</h4></b-col>

        <b-col cols="12" lg="4">
          <validation-provider
            name="Commodity"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Commodity<font class="red">*</font></label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Commodity"
                v-model="quotationInfo.goods_type"
                :options="goods_types"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Commodity description"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Commodity description</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.mo_ta"
                placeholder="Commodity description"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Gross Weight (kgs)"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Total Gross Weight (kg)</label>
              <!-- <b-form-input
                type="number"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.trong_luong"
                placeholder="Gross Weight (kgs)"
              /> -->
              <cleave
                :state="errors.length > 0 ? false : null"
                :options="$Utils.CONSTANTS.cleaveNumeral"
                :disabled="readonly"
                v-model="quotationInfo.trong_luong"
                class="form-control"
                placeholder="Gross Weight (kgs)"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-group>
            <label>Measurement (cbm)</label>
            <!-- <b-form-input
              type="number"
              :disabled="readonly"
              v-model="quotationInfo.so_khoi"
              placeholder="Measurement (kgs)"
            /> -->
            <cleave
              :options="$Utils.CONSTANTS.cleaveNumeral"
              :disabled="readonly"
              v-model="request_quotation.so_khoi"
              class="form-control"
              placeholder="Measurement (kgs)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Handled type"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Handled type</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Handled type"
                v-model="quotationInfo.handled_type"
                :options="handed_types"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider
            name="Total Charge Weight (kg)"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Total Charge Weight (kg)</label>
              <cleave
                :options="$Utils.CONSTANTS.cleaveNumeral"
                :state="errors.length > 0 ? false : null"
                :disabled="true"
                v-model="quotationInfo.totalChargeWeight"
                class="form-control"
                placeholder="Total Charge Weight (kg)"
              />
              <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.totalChargeWeight"
                    placeholder="Total Charge Weight (kg)"
                  /> -->
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider
            name="Package type"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package type</label>

              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Package type"
                v-model="quotationInfo.package_type"
                :options="cont_types.filter((i) => i.group === 'packaging')"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="6">
          <validation-provider
            name="Package Number"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Package Number</label>
              <b-form-input
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.packageNumber"
                placeholder="Package Number"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Van -->

        <b-col v-if="quotationInfo.has_van_trucking" cols="12" class="pt-1"
          ><h4>Shipment Informations</h4></b-col
        >
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <b-form-group>
            <label>Booking/HBL/INV</label>
            <b-form-input
              :disabled="readonly"
              placeholder="Booking/HBL/INV"
              v-model="quotationInfo.HBL"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <b-form-group>
            <label>Shipping Type</label>
            <Select2
              :disabled="readonly"
              placeholder="Shipping Type"
              v-model="quotationInfo.shippingType"
              :options="
                request_quotation.service_type == 5
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : request_quotation.service_type == 6
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : transport_types.filter((i) => [1, 2].includes(i.id))
              "
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider name="Truck Type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Truck Type</label>
              <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="Truck Type"
                v-model="quotationInfo.truck_type"
                :options="cont_types.filter((i) => i.group === 'van truck')"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider name="Quantity" #default="{ errors }" rules="">
            <b-form-group>
              <label>Quantity</label>
              <b-form-input
                placeholder="Quantity"
                type="number"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.so_luong"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="Pick up"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Pick up<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select4
                  v-model="quotationInfo.pickup_location"
                  v-if="!quotationInfo.isHideShows"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Pick up"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: pickupFilter,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                <b-form-input
                  v-if="quotationInfo.isHideShows"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="quotationInfo.other_pickup_location"
                  placeholder="Enter pick up "
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShows"
                  v-model="quotationInfo.isHideShows"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="Delivery"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>Delivery<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select4
                  v-model="quotationInfo.delivery_location"
                  v-if="!quotationInfo.isHideShowPk"
                  :classProp="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Delivery"
                  :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: deliveryFilter,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }"
                />
                <b-form-input
                  v-if="quotationInfo.isHideShowPk"
                  :state="errors.length > 0 ? false : null"
                  :disabled="readonly"
                  v-model="quotationInfo.other_delivery_location"
                  placeholder="Enter pick up"
                />
                <b-form-checkbox
                  :disabled="readonly"
                  v-on:change="hideShowsPk"
                  v-model="quotationInfo.isHideShowPk"
                  class="check_input"
                  >Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Pick up date</label>

              <section>
                <date-picker
                  ref="datePicker"
                  v-model="quotationInfo.pick_up_date"
                  type="datetime"
                  class="w-full"
                  :disabled="readonly"
                  value-type="format"
                  title-format="DD-MM-YYYY"
                  :state="errors.length > 0 ? false : null"
                  time-title-format="DD-MM-YYYY"
                  placeholder="Select datetime"
                  :show-time-panel="showTimePanel"
                  format="DD-MM-YYYY HH:mm"
                  @close="handleOpenChange"
                >
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel ? "Date" : "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>Delivery Date</label>

              <section>
                <date-picker
                  ref="datePicker"
                  v-model="quotationInfo.delivery_date"
                  :disabled-date="disabledRangeDelivery"
                  type="datetime"
                  class="w-full"
                  value-type="format"
                  :disabled="readonly"
                  :state="errors.length > 0 ? false : null"
                  title-format="DD-MM-YYYY"
                  time-title-format="DD-MM-YYYY"
                  placeholder="Select datetime"
                  :show-time-panel="showTimePanel"
                  format="DD-MM-YYYY HH:mm"
                  @close="handleOpenChange"
                >
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel ? "Date" : "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="PIC pick up"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC pick up</label>
              <b-form-input
                placeholder="PIC pick up"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.PICPickUp"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="quotationInfo.has_van_trucking">
          <validation-provider
            name="PIC Delivery"
            #default="{ errors }"
            rules=""
          >
            <b-form-group>
              <label>PIC Delivery</label>
              <b-form-input
                placeholder="PIC Delivery"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="quotationInfo.PICDelivery"
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- end Van -->

        <!-- Custom  -->

        <b-col cols="12" v-if="quotationInfo.has_customs">
          <b-row>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2
                  :disabled="readonly"
                  placeholder="Customs type"
                  v-model="quotationInfo.customs_type"
                  :options="customs_types"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Business type"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label>Business type<font class="red">*</font></label>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="Business type"
                    v-model="quotationInfo.business_type"
                    :options="business_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider
                name="Place of Custom declaration"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >Place of Custom declaration<font class="red"
                      >*</font
                    ></label
                  >
                  <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="quotationInfo.customs_addr"
                    placeholder="Place of Custom declaration"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input
                  :disabled="readonly"
                  v-model="quotationInfo.hs_code"
                  placeholder="HS Code"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- end custom -->
        <b-col cols="12">
          <b-form-group>
            <label>Notes</label>
            <b-form-textarea
              rows="5"
              :disabled="readonly"
              v-model="quotationInfo.notes"
              placeholder="Notes"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
    <AttachFile class="px-2" :quotationInfo.sync="quotationInfo" />
  </section>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AttachFile from "./components/AttachFile.vue";
import Select2 from "v-select2-component";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import mixins from "./mixin/mixin";
export default {
  mixins: [mixins],

  props: ["request_quotation"],
  components: {
    ValidationProvider,
    Select2,
    ValidationObserver,
    AttachFile,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      readonly: false,
      cut_off: "",
      quotationInfo: {
        so_khoi: null,
        trong_luong: null,
        totalChargeWeight: null,
        pick_up_date: null,
        delivery_date: null,
      },
      moment,
      useLocations: [],
    };
  },
  watch: {
    cut_off(n) {
      this.$emit("cut-off", n);
    },
    ...["quotationInfo.so_khoi", "quotationInfo.trong_luong"].reduce(
      (watchers, key) => ({
        ...watchers,
        [key](newVal, oldVal) {
          var vm = this;

          if (vm.quotationInfo.service_type == 1) {
            vm.quotationInfo.trong_luong > vm.quotationInfo.so_khoi * 167
              ? (vm.quotationInfo.totalChargeWeight =
                  vm.quotationInfo.trong_luong)
              : (vm.quotationInfo.totalChargeWeight =
                  vm.quotationInfo.so_khoi * 167);
          }
        },
      }),
      {}
    ),
  },
  computed: {
    ...mapState("masterData", [
      "locations",
      "ports",
      "cont_types",
      "goods_types",
      "regions",
      "deports_locations",
      "business_types",
      "customs_types",
      "transport_types",
      "incoterms",
      "regions",
      "shipping_lines",
      "handed_types"
    ]),
    isVolume() {
      return (
        this.quotationInfo.has_van_trucking || this.quotationInfo.has_customs
      );
    },
    shippingTypeOptions() {
      return [...this.locations, ...this.regions];
    },
  },

  created() {
    this.$loading.show();
    this.quotationInfo = {};
    if (this.request_quotation) {
      this.getLocation();
      this.quotationInfo.id = this.request_quotation.bookingID;

      this.quotationInfo.has_van_trucking =
        this.request_quotation.has_van_trucking;
      this.quotationInfo.has_customs = this.request_quotation.has_customs;
      this.quotationInfo.service_type = this.request_quotation.service_type;
      this.quotationInfo.size_ = {};
      this.quotationInfo.size_.length_ = this.request_quotation.size_.length_;
      this.quotationInfo.size_.height_ = this.request_quotation.size_.height_;
      this.quotationInfo.size_.width_ = this.request_quotation.size_.width_;
      this.quotationInfo.so_khoi = this.request_quotation.so_khoi;
      this.quotationInfo.handled_type = this.request_quotation.handled_type;
      this.quotationInfo.package_type = this.request_quotation.package_type;
      // this.quotationInfo.from_date = this.request_quotation.from_date;
      // this.quotationInfo.to_date = this.request_quotation.to_date;
      this.quotationInfo.customs_type = this.request_quotation.customs_type;

      this.quotationInfo.business_type = this.request_quotation.business_type;

      this.quotationInfo.customs_addr = this.request_quotation.customs_addr;

      this.quotationInfo.hs_code = this.request_quotation.hs_code;
      this.quotationInfo.notes = this.request_quotation.notes;

      this.quotationInfo.files = this.request_quotation.files;
      this.quotationInfo.incoterms = this.request_quotation.incoterms;
      this.quotationInfo.mo_ta = this.request_quotation.mo_ta;

      this.quotationInfo.so_luong = this.request_quotation.so_luong;

      this.quotationInfo.goods_type = this.request_quotation.goods_type;
      this.quotationInfo.trong_luong = this.request_quotation.trong_luong;

      this.quotationInfo.pod_port = this.request_quotation.pod_port;
      this.quotationInfo.pol_port = this.request_quotation.pol_port;
      this.quotationInfo.HBL = this.request_quotation.HBL;
      this.quotationInfo.packageNumber = this.request_quotation.packageNumber;
      this.quotationInfo.shippingType = this.request_quotation.shippingType;
      this.quotationInfo.truck_type = this.request_quotation.truck_type;
      this.quotationInfo.PICPickUp = this.request_quotation.PICPickUp;
      this.quotationInfo.PICDelivery = this.request_quotation.PICDelivery;

      this.quotationInfo.PICDelivery = this.request_quotation.PICDelivery;
      this.quotationInfo.cargo_ready = this.request_quotation.cargo_ready;
      this.quotationInfo.paymentTerms = this.request_quotation.paymentTerms;
      this.quotationInfo.totalChargeWeight =
        this.request_quotation.totalChargeWeight;

      this.quotationInfo.shipping_line = this.request_quotation.shipping_line;
    }
  },
  mounted() {
    this.cut_off = this.quotationInfo.cut_off;
  },
  methods: {
    disabledRangeDelivery: function (date) {
      if (this.quotationInfo.pick_up_date) {
        var mydate = moment(this.quotationInfo.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
      if (!this.isHideShow) {
        this.quotationInfo.pickup_location = "";
      }
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
      if (!this.isHideShowPk) {
        this.quotationInfo.delivery_location = "";
      }
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
  },
};
</script>

<style>
</style>